import { Box, Link, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useQuery } from "react-query";
import { OverlayLoader } from "../../ui/atoms/OverlayLoader";
import { ApiKeysAPI } from "../../utils/api/requests/api-keys-requests";
import { EmptyData } from "../../ui/atoms/EmptyData";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import { AddApiKeyModal } from "./ui/modals/AddApiKeyModal";
import { ApiKeyItem } from "./ui/molecules/ApiKeyItem";
import { queryClient } from "../..";
import { useTranslation } from "react-i18next";

const gridTemplateColumns = "1.4fr 0.5fr 0.3fr 0.1fr";

export const ApiKeys = () => {
  const { t } = useTranslation();
  const [modal, setModal] = useState(false);
  const { data, isLoading, refetch } = useQuery({
    queryFn: ApiKeysAPI.getKeys,
    onError: (error) => {},
    queryKey: "Api-keys",
    refetchOnMount: true,
    refetchOnWindowFocus: false,
  });

  useEffect(() => {
    return () => {
      queryClient.resetQueries("Api-keys");
    };
  }, []);

  return (
    <Box
      sx={{ width: "100%", minWidth: { xs: "none", sm: "none", md: "1024px" } }}
    >
      <Typography sx={{ maxWidth: "600px", mb: "6px", fontWeight: "bold" }}>
        {t("apiKeys.text_1")}
      </Typography>
      <Typography sx={{ maxWidth: "600px", mb: "12px" }}>
        {t("apiKeys.text_2")}
      </Typography>
      <Typography sx={{ maxWidth: "600px", mb: "6px", fontWeight: "bold" }}>
        {t("apiKeys.text_3")}
      </Typography>
      <Typography sx={{ maxWidth: "600px", mb: "12px" }}>
        {t("apiKeys.text_4")}{" "}
        <Link
          href="https://client-api.unlimsmm.com/docs"
          color="rgb(25, 118, 210)"
        >
          {t("apiKeys.text_5")}
        </Link>{" "}
        {t("apiKeys.text_6")}
      </Typography>
      <Typography sx={{ maxWidth: "600px", mb: "6px", fontWeight: "bold" }}>
        {t("apiKeys.text_7")}
      </Typography>
      <Typography sx={{ maxWidth: "600px", mb: "12px" }}>
        {t("apiKeys.text_8")}
      </Typography>
      <Typography sx={{ maxWidth: "600px", mb: "6px", fontWeight: "bold" }}>
        {t("apiKeys.text_9")}
      </Typography>
      <Typography sx={{ maxWidth: "600px", mb: "12px" }}>
        {t("apiKeys.text_10")}
      </Typography>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          mb: "24px",
        }}
      >
        <Typography variant="h4">{t("apiKeys.API_tokens")}</Typography>
        <AddCircleOutlineIcon
          onClick={() => setModal(true)}
          sx={{
            ml: "8px",
            mt: "4px",

            cursor: "pointer",
            "&:hover": {
              color: "rgb(105,65,198)",
            },
          }}
        />
      </Box>
      {isLoading && <OverlayLoader />}
      {data?.length ? (
        <Box
          sx={{
            width: "100%",
            boxShadow:
              "rgba(0, 0, 0, 0.04) 0px 5px 22px, rgba(0, 0, 0, 0.03) 0px 0px 0px 0.5px",
            borderRadius: "16px",
          }}
        >
          <Box
            sx={{
              backgroundColor: "rgb(248, 249, 250)",
              height: "40px",
              display: { xs: "none", sm: "none", md: "grid" },
              gridTemplateColumns: gridTemplateColumns,
              px: "24px",
              py: "8px",
              color: "rgb(47, 55, 70)",
              textTransform: "uppercase",
              borderRadius: "16px 16px 0 0",
            }}
          >
            <Box sx={{ display: "flex", alignItems: "center" }}>
              <Typography sx={{ fontSize: "0.875rem" }}>
                {t("apiKeys.token")}
              </Typography>
            </Box>

            <Box sx={{ display: "flex", alignItems: "center" }}>
              <Typography sx={{ fontSize: "0.875rem" }}>
                {t("apiKeys.expiration")}
              </Typography>
            </Box>
            <Box sx={{ display: "flex", alignItems: "center" }}>
              <Typography sx={{ fontSize: "0.875rem" }}>
                {t("apiKeys.read_only")}
              </Typography>
            </Box>

            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "end",
              }}
            >
              <Typography sx={{ fontSize: "0.875rem" }}></Typography>
            </Box>
          </Box>

          {data?.map((apiKey) => (
            <ApiKeyItem
              apiKey={apiKey}
              gridTemplateColumns={gridTemplateColumns}
              key={apiKey.id}
            />
          ))}
        </Box>
      ) : null}

      {!data?.length && <EmptyData text={t("apiKeys.emptyData")} />}
      <AddApiKeyModal
        open={modal}
        handleClose={() => setModal(false)}
        refetch={refetch}
      />
    </Box>
  );
};
